export default __webpack_public_path__ + "static/media/imagePVI_1.849a15cb.png";